import { Directive, ElementRef, Input, Renderer2, AfterViewInit } from '@angular/core';

@Directive({
  standalone: true,
  selector: '[textFadeIn]'
})
export class FadeInDirective implements AfterViewInit {
  @Input() delay: number; // Initial delay for first word (0.1s)
  @Input() animationDuration: number; // Default animation duration (0.8s)

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngAfterViewInit() {
    this._wrapContent();
  }

  private _wrapContent() {
    const text = this.el.nativeElement.textContent.trim();
    let words = text.split('\n\n');
    let content = '';

    words.forEach((word, index) => {
      const delayMs = (index + 1) * this.delay; // Increasing delay for each word
      content += `
      <div class="text-layer" style="animation-delay: ${delayMs}ms;">
        <span class="black-text">${word}</span>
        <span class="gradient">${word}</span>
      </div>
    `;
    });

    this.renderer.setProperty(this.el.nativeElement, 'innerHTML', content);
  }
}
